import React from 'react';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';

import { Button, SECONDARY, PRIMARY } from '@glu/buttons-react';

import { WORKFLOWS, TRANSFER_ACTIONS } from 'constants.js';
import { numberToCurrency } from 'utils/currency';
import ButtonsContainer from 'components/buttonsContainer/ButtonsContainer';
import useLocale from 'components/useLocale';

const { MODIFY, VIEW } = TRANSFER_ACTIONS;

const RecurringTransferFooterComponent = ({
  amount = '0.00',
  classes,
  formValidationInProgress = false,
  onCancel,
  onCreate,
  onDelete
}) => {
  const history = useHistory();
  const locale = useLocale();
  const { action, id: templateId } = useParams();

  return (
    <div className={classes.footer}>
      <div className={classes.sectionWrapper}>
        <div className={classes.section}>
          <div className={classes.amount}>{amount && numberToCurrency(amount)}</div>
        </div>
        <ButtonsContainer>
          {action === VIEW && (
            <>
              <Button
                className="btn btn-primary"
                data-qa="create-recurring-modify"
                onClick={() => {
                  const pathname = `${WORKFLOWS.MODIFY_RECURRING_TRANSFERS}/${templateId}`;

                  history.push({
                    pathname,
                    state: {
                      change: true
                    }
                  });
                }}
                type="button"
                variant={PRIMARY}
              >
                {locale['common.modify']}
              </Button>
              <Button
                className="btn btn-secondary"
                data-qa="create-recurring-delete"
                onClick={onDelete}
                type="button"
                variant={SECONDARY}
              >
                {locale['common.delete']}
              </Button>
            </>
          )}
          {action === MODIFY && (
            <Button
              className="btn btn-primary"
              data-qa="create-recurring-create"
              onClick={onCreate}
              type="button"
              variant={PRIMARY}
            >
              {locale['common.modify']}
            </Button>
          )}
          {!action && (
            <Button
              aria-busy={formValidationInProgress}
              className="btn btn-primary"
              data-qa="create-recurring-create"
              onClick={onCreate}
              type="button"
              variant={PRIMARY}
            >
              {locale['common.create']}
            </Button>
          )}
          <Button
            className="btn btn-secondary"
            data-qa="create-recurring-cancel"
            onClick={onCancel}
            type="button"
            variant={SECONDARY}
          >
            {locale['common.cancel']}
          </Button>
        </ButtonsContainer>
      </div>
    </div>
  );
};

RecurringTransferFooterComponent.propTypes = {
  amount: PropTypes.number,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  formValidationInProgress: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onCreate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default RecurringTransferFooterComponent;
